import { Btn, BtnGreen, BtnNormal } from "./localStyle";

const BtnLink = ({
  to,
  title,
  Icon,
  type,
  onclick,
  spacingWord,
  textCentre,
  normalFont,
}) => {
  switch (type) {
    case "LINK":
      return (
        <Btn to={to}>
          {" "}
          {Icon} {title}
        </Btn>
      );
    case "NORMAL":
      return (
        <BtnNormal
          $normalFont={normalFont}
          $textCentre={textCentre}
          $spacingWord={spacingWord}
          onClick={onclick}
        >
          {Icon} {title}
        </BtnNormal>
      );
    case "GREEN":
      return (
        <BtnGreen $spacingWord={spacingWord} onClick={onclick}>
          {Icon} {title}
        </BtnGreen>
      );

    default:
      return (
        <Btn to={to}>
          {" "}
          {Icon} {title}
        </Btn>
      );
  }
};

export default BtnLink;

// BtnNormal
